import { render, staticRenderFns } from "./opt-in-whatsapp.vue?vue&type=template&id=1523554e&"
import script from "./opt-in-whatsapp.vue?vue&type=script&lang=js&"
export * from "./opt-in-whatsapp.vue?vue&type=script&lang=js&"
import style0 from "./opt-in-whatsapp.vue?vue&type=style&index=0&id=1523554e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports